import ImportTrainingData from './ImportTrainingData';

export default ImportTrainingData;
